import { z } from 'zod';

/**
 * SIL-1007 — the current Terms of Service version. A hardcoded code constant
 * (not a DB-backed version table — the spec rejects that as YAGNI at current
 * scale, see docs/superpowers/specs/2026-09-10-tos-clickwrap-gate-design.md).
 * Bumping this is a code change (PR + deploy), NOT a DB write, and makes
 * every existing user's most recent tos_acceptance row stale automatically:
 * clientAuthMiddleware always checks "does a row exist at the CURRENT
 * constant", so the hard block re-applies platform-wide on next request with
 * no backfill needed.
 *
 * Imported by both the API (apps/api/src/middleware/clientAuth.ts, the
 * /api/client/tos routes) and, later, the UI (SIL-1008).
 */
export const TOS_VERSION = '2026-09-10';

/**
 * Static ToS text served by GET /api/client/tos. Plain text/markdown — the
 * UI (SIL-1008) renders it as-is. Kept alongside TOS_VERSION so a version
 * bump and its text always land in the same commit.
 */
export const TOS_TEXT = `# SiliconX Terms of Service

Effective ${TOS_VERSION}

By using the SiliconX customer portal, you agree to these Terms of Service.
This is placeholder legal text — replace with the actual reviewed ToS copy
before this version is used to gate production traffic.`;

/** GET /api/client/tos response shape. */
export const tosResponseSchema = z.object({
  version: z.string(),
  text: z.string(),
});
export type TosResponse = z.infer<typeof tosResponseSchema>;

/** POST /api/client/tos/accept response shape. */
export const tosAcceptResponseSchema = z.object({
  version: z.string(),
  acceptedAt: z.string(),
});
export type TosAcceptResponse = z.infer<typeof tosAcceptResponseSchema>;

/** Structured 403 body clientAuthMiddleware returns when the current ToS is unaccepted. */
export interface TosRequiredError {
  error: 'tos_required';
  version: string;
}
